import produce from 'immer'
import { RiAddFill, RiCloseCircleLine, RiSettings5Line } from 'react-icons/ri'
import { useUpdateEffect } from 'react-use'

import Classnames from 'classnames'
import { useRecoilState, useRecoilValue, useRecoilCallback } from 'recoil'
import { content, content_block } from '@/store/template/content'
import {
  isBuilder,
  screen,
  screenOpen,
  editSectionId,
  editSectionWrapperId,
} from '@/store/builder/store'
import {
  undoHistoryAction,
  undoHistoryActionCount,
} from '@/store/builder/history'

// components
import Title from '@/components/onepager/sections/Title'
// import MultiShortTextDisplay from '@/components/onepager/sections/_multishorttext/display'

import TextareaAutosize from 'react-textarea-autosize'

function Table({ id, contentID, sectionData, wrapperId }) {
  const isBuilderApp = useRecoilValue(isBuilder)
  const [getSreen, setScreen] = useRecoilState(screen)
  const [getScreenOpen, setScreenOpen] = useRecoilState(screenOpen)
  const [getContent, setContent] = useRecoilState(content(contentID))
  const [getEditSectionId, setEditSectionId] = useRecoilState(editSectionId)
  const [getEditSectionWrapperId, setEditSectionWrapperId] = useRecoilState(
    editSectionWrapperId
  )
  const [getHistoryAction, setHistoryAction] = useRecoilState(undoHistoryAction)
  const [getHistoryActionCount, setHistoryActionCount] = useRecoilState(
    undoHistoryActionCount
  )

  // undoSystem -- Content System
  useUpdateEffect(async () => {
    if (isBuilderApp) {
      if (!getHistoryAction) {
        setHistoryActionCount(getHistoryActionCount + 1)
      } else {
        setHistoryAction(false)
      }
    }
  }, [getContent])

  const openEditor = () => {
    setScreen('editsection')
    setScreenOpen(true)
    setEditSectionId(id)
    setEditSectionWrapperId(wrapperId)
  }

  const addNewRow = () => {
    // get column length
    const colLength = sectionData.data.columns.length

    let newRow = []

    for (var i = 1; i <= colLength; i++) {
      newRow.push('')
    }

    const nextState = produce(getContent, draft => {
      draft.blocks.push(newRow)
    })
    setContent(nextState)
  }

  const preventEnter = e => {
    if (e.key === 'Enter') {
      e.preventDefault()
    }
  }

  return (
    <div className="sectionTable">
      {/* HEADER */}
      <div
        className={`sectionTableHeader relative grid grid-cols-${sectionData.data.columns.length} gap-0`}
      >
        {sectionData.data.columns.map((column, index) => (
          <div
            key={column.id}
            className="sectionTableRowItem  text-xl font-bold py-3 px-4"
          >
            {column.label}
          </div>
        ))}

        {/* edit icon */}
        {isBuilderApp && (
          <div
            onClick={openEditor}
            className="absolute top-3 right-3 opacity-50 hover:opacity-100 hover:shadow p-1 text-lg rounded  hover:bg-blue-500 hover:text-white cursor-pointer"
          >
            <RiSettings5Line />
          </div>
        )}
      </div>

      {/* BODY */}

      {/* Loop based on headings - if no value, just be blank */}
      {getContent.blocks.map((row, rowIndex) => (
        <div
          key={rowIndex}
          className={`grid grid-cols-${sectionData.data.columns.length} gap-0`}
        >
          {[...Array(sectionData.data.columns.length)].map((col, colIndex) => (
            <div
              key={'col-' + colIndex}
              className="sectionTableColItem relative group"
            >
              <TextareaAutosize
                className="text-lg font-medium"
                value={getContent.blocks[rowIndex][colIndex]}
                placeholder="..."
                onKeyDown={preventEnter}
                onChange={e => {
                  const nextState = produce(getContent, draft => {
                    draft.blocks[rowIndex][colIndex] = e.target.value
                  })
                  setContent(nextState)
                }}
              />

              {colIndex + 1 == sectionData.data.columns.length && (
                <div
                  onClick={() => {
                    const nextState = produce(getContent, draft => {
                      // draft.blocks[rowIndex][colIndex] = e.target.value
                      if (rowIndex !== -1) draft.blocks.splice(rowIndex, 1)
                    })
                    setContent(nextState)
                  }}
                  className="absolute right-0 top-0 cursor-pointer mr-3 mt-4 text-2xl opacity-0 group-hover:opacity-100 text-gray-300 hover:text-red-700"
                >
                  <RiCloseCircleLine />
                </div>
              )}
            </div>
          ))}
        </div>
      ))}

      {/* add */}
      <button
        onClick={addNewRow}
        className="mt-5 mb-5 ml-5  text-base font-bold addTaskBtn hover:text-white p-2 px-2 pr-3 rounded flex items-center"
      >
        <div className="mr-1 text-lg">
          <RiAddFill />
        </div>
        {sectionData.data.addbutton}
      </button>

      {/* <Title id={id} title={sectionData.title} prompt={sectionData.prompt} /> */}

      {/* <div className="boxBody"> */}
      {/* TABLE:: */}
      {/* {JSON.stringify(getContent.blocks)} */}

      {/* {sectionData.data.map((question, index) => (
          <div key={index} className="mb-8">
            <MultiShortTextDisplay id={contentID} sectionData={question} index={index} />
          </div>
        ))} */}

      {/* </div> */}
    </div>
  )
}

export default Table
